import React, { useEffect, useState } from "react";
import { toast } from "react-toastify";

const API_BASE = "https://mediapi.onlinepharmaque.in/api/v1";

const CategoryModal = ({
  isOpen,
  toggleModal,
  setCategories,
  isEditMode,
  categoryToEdit,
}) => {
  const [categoryName, setCategoryName] = useState("");
  const [errors, setErrors] = useState({});

  useEffect(() => {
    if (isEditMode && categoryToEdit) {
      setCategoryName(categoryToEdit.MaincategoryName);
    } else {
      setCategoryName("");
    }
  }, [isEditMode, categoryToEdit]);

  const validateForm = () => {
    const err = {};
    if (!categoryName.trim()) err.name = "Category name required";
    setErrors(err);
    return Object.keys(err).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) return;

    const url = isEditMode
      ? `${API_BASE}/updatecategory/${categoryToEdit.id}`
      : `${API_BASE}/addcategory`;

    const method = isEditMode ? "PATCH" : "POST";

    try {
      const res = await fetch(url, {
        method,
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          MaincategoryName: categoryName,
        }),
      });

      const data = await res.json();

      console.log("RESPONSE:", data);

      if (data.status === "fail" || data.status === "error") {
        return toast.error(data.message);
      }

      setCategories((prev) =>
        isEditMode
          ? prev.map((c) =>
              c.id === categoryToEdit.id ? data.result : c
            )
          : [data.result, ...prev]
      );

      toast.success(
        isEditMode ? "Category Updated" : "Category Added"
      );

      toggleModal();
      setCategoryName("");

    } catch (err) {
      console.error(err);
      toast.error("Something went wrong");
    }
  };

  if (!isOpen) return null;

  return (
    <>
      {/* Overlay */}
      <div
        className="fixed inset-0 bg-black/70 z-40"
        onClick={toggleModal}
      />

      {/* Modal */}
      <div className="fixed inset-0 z-50 flex items-center justify-center">
        <div className="w-[420px] rounded-xl bg-[#1F2A40] border border-[#2E3B55] shadow-2xl">

          {/* Header */}
          <div className="flex justify-between items-center px-6 py-4 border-b border-[#2E3B55]">
            <h2 className="text-lg font-semibold text-white">
              {isEditMode ? "Edit Category" : "Add Category"}
            </h2>
            <button
              onClick={toggleModal}
              className="text-gray-400 hover:text-red-500 text-xl"
            >
              ✕
            </button>
          </div>

          {/* Body */}
          <form onSubmit={handleSubmit} className="p-6 space-y-4">
            <div>
              <label className="text-sm text-gray-400">
                Category Name
              </label>
              <input
                value={categoryName}
                onChange={(e) => setCategoryName(e.target.value)}
                placeholder="Enter category name"
                className="mt-1 w-full px-4 py-2 rounded-lg bg-[#141B2D] text-white border border-[#2E3B55] outline-none focus:border-emerald-500"
              />
              {errors.name && (
                <p className="text-red-500 text-xs mt-1">
                  {errors.name}
                </p>
              )}
            </div>
          </form>

          {/* Footer */}
          <div className="flex justify-end gap-3 px-6 py-4 border-t border-[#2E3B55]">
            <button
              onClick={toggleModal}
              className="px-4 py-2 bg-red-500 text-white rounded-lg"
            >
              Cancel
            </button>
            <button
              onClick={handleSubmit}
              className="px-4 py-2 bg-emerald-500 text-white rounded-lg"
            >
              Save
            </button>
          </div>

        </div>
      </div>
    </>
  );
};

export default CategoryModal;